import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Personalizados
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ProfileAuthenticationComponent } from './profile-authentication/profile-authentication.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../modulos/material.module';
import { ResendPinComponent } from './resend-pin/resend-pin.component';
import { PipesModule } from '../modulos/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { NgxCaptchaModule } from 'ngx-captcha';
import { TermsConditions } from './profile-authentication/terms-conditions/terms-conditions.component';
import { HomeModule } from '../modulos/home.module';
import { InscripcionOsComponent } from './inscripcion-os/inscripcion-os.component';
//// Necesito que este en entidades y en auth module. (por fuera del proyecto, en la inscripción y por dentro para las pantallas de backoffice) - RESUELTO MOVIENDO A SHARED
import { DirectivaFechasDirective } from './../Directives/directiva-fechas/directiva-fechas.directive';

// Profile Authentication Refactor
import { AuthenticationLayoutComponent } from './profile-authentication/authentication-layout/authentication-layout.component';
import { LoginComponent as AuthLoginComponent } from './profile-authentication/login/login.component';
import { RegisterComponent as AuthRegisterComponent } from './profile-authentication/register/register.component';
import { ForgotPasswordComponent } from './profile-authentication/recover/forgot-password.component';

@NgModule({
    declarations: [
        LoginComponent,
        RegisterComponent,
        ProfileAuthenticationComponent,
        ActivateAccountComponent,
        ResetPasswordComponent,
        ResendPinComponent,
        TermsConditions,
        InscripcionOsComponent,
        
        // New Auth Refactor
        AuthenticationLayoutComponent,
        AuthLoginComponent,
        AuthRegisterComponent,
        ForgotPasswordComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        MaterialModule,
        PipesModule,
        SharedModule,
        NgxCaptchaModule,
        HomeModule,
        FormsModule,
    ],
})
export class AuthModule {}
